var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-remove',{attrs:{"type":"morble","name":_vm.morble.name,"on-remove":_vm.onRemove},on:{"close":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }